import React from 'react'
import { FlexColumn, Text, Card, Button } from 'elements'

export default function FreeSubscriptionCard({ working, isTrial, handleCheckout, ...props }) {
  return (
    <Card
      bg="background.0"
      pb="xxxlarge"
      pt="xxxlarge"
      mb="xxxlarge"
      width="768px"
      flexDirection="column"
      {...props}
    >
      <FlexColumn justifyContent="center" pt="large" pb="large" alignItems="center">
        <Text fontSize="xxlarge" mb="large">
          You're on the{' '}
          {isTrial ? (
            <b>Free Trial.</b>
          ) : (
            <>
              <b>Free</b> plan.
            </>
          )}
        </Text>
        <Text fontSize="large" mt="large" color="neutral.3" fontStyle="italic">
          {isTrial
            ? 'When your trial is over you will have access to one client account'
            : 'You have access to one client account'}
        </Text>
        <Text fontSize="large" mt="xlarge" color="neutral.3">
          To unlock more client accounts, upgrade to the <b>Team</b> plan today!
        </Text>
        <Text fontSize="large" mt="xlarge" mb="medium">
          <b>Team</b>
        </Text>
        <Text fontSize="xxxlarge" lineHeight="xxxlarge" fontWeight="bold">
          $5
        </Text>
        <Text fontSize="large" mt="small" mb="xlarge">
          per client per month
        </Text>
        <Button disabled={working} onClick={handleCheckout} kind="primary">
          {working ? 'Please wait...' : 'Upgrade Your Plan'}
        </Button>
      </FlexColumn>
    </Card>
  )
}
